/**
 * AnalysisTips Component
 *
 * Static tips content for getting better movement analysis results.
 * Mode: Deep Analysis (Mode 3)
 */
import React from 'react';

export const AnalysisTips = () => {
  return (
    <div className="p-4 bg-[#0b1118] rounded-xl border border-white/10">
      <h3 className="text-sm font-medium text-zinc-300 mb-2">How to get the best analysis:</h3>
      <ul className="list-disc pl-5 space-y-1.5 text-sm text-zinc-400">
        <li>Record clear video from a stable position where your entire body is visible</li>
        <li>Perform the technique at a moderate speed so details are visible</li>
        <li>Ask specific questions about aspects you want to improve</li>
        <li>For partner techniques, ensure both participants are visible</li>
        <li>Good lighting makes a significant difference in analysis quality</li>
      </ul>
      <p className="mt-3 text-xs text-zinc-600">
        Note: All videos are processed securely and not stored permanently after analysis.
      </p>
    </div>
  );
};
